import { render, staticRenderFns } from "./OrthoPriorTreatmentPeriod.vue?vue&type=template&id=13d4281a&scoped=true"
import script from "./OrthoPriorTreatmentPeriod.vue?vue&type=script&lang=js"
export * from "./OrthoPriorTreatmentPeriod.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13d4281a",
  null
  
)

export default component.exports